package anjuros.development.components

import androidx.compose.runtime.Composable
import anjuros.development.components.language.LocalText
import anjuros.development.modules.FAQ
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import anjuros.development.util.FaqHeaderStyle
import anjuros.development.util.FaqSubheaderStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun FAQCard(fAQ: FAQ, visibility: Boolean, onClick:()->Unit){


    Box(modifier =  Modifier.fillMaxWidth().backgroundColor(Colors.White)
    ){


        Column(modifier = Modifier.fillMaxWidth().backgroundColor(Colors.White).align(Alignment.Center)){
            Box(modifier = Modifier.fillMaxWidth().backgroundColor(Colors.White).cursor(Cursor.Pointer).onClick {
                onClick()
            }){
                val symbol = if(visibility) "-" else "+"
                P(
                    attrs = FaqHeaderStyle.toModifier()
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Bold)
                        .color(Theme.Primary.rgb)
                        .toAttrs()
                ) {
                    Text("$symbol  ${LocalText(fAQ.question)}")

                }
            }
            Box(modifier = Modifier
                .height(if(visibility) 60.px else 0.px)
                .transition(Transition.of("height", 500.ms))){
                P(
                    attrs = FaqSubheaderStyle.toModifier()
                        .margin(left=10.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Normal)
                        .color(if(visibility) Theme.Secondary.rgb else Colors.White)
                        .transition(Transition.of("color", 600.ms))
                        .toAttrs()
                ) {
                    Text(LocalText(fAQ.answer))

                }
            }
        }
    }
}